import gql from "graphql-tag";

export const SAVE_DEVICE_SETTINGS = gql`
  mutation SaveDeviceSettings($saveDeviceSettingsInput: SaveDeviceSettingsInput!) {
    saveDeviceSettings(saveDeviceSettingsInput: $saveDeviceSettingsInput) {
      ... on SaveDeviceSettingsErrorOutput {
        errorReason
      }
      ...on SaveDeviceSettingsOutput {
        __typename
      }
    }
  }
`;

export const SAVE_USER_SETTINGS = gql`
mutation SaveUserProfile($saveUserProfileInput: SaveUserProfileInput!) {
  saveUserProfile(saveUserProfileInput: $saveUserProfileInput) {
    ... on SaveUserProfileErrorOutput {
      errorReason
    }
    ...on SaveUserProfileOutput {
    __typename
    }
  }
}
`;